import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const CloseIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='-2 -2 26 26'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M1 1L21 21' stroke='currentColor' strokeLinecap='round' />
      <path d='M21 1L1 21' stroke='currentColor' strokeLinecap='round' />
    </svg>
  )
}
